import { render, staticRenderFns } from "./MinusIcon.vue?vue&type=template&id=82ad6f58"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82ad6f58')) {
      api.createRecord('82ad6f58', component.options)
    } else {
      api.reload('82ad6f58', component.options)
    }
    module.hot.accept("./MinusIcon.vue?vue&type=template&id=82ad6f58", function () {
      api.rerender('82ad6f58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/MinusIcon.vue"
export default component.exports